import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {useParams} from "react-router-dom";
import {baseUrl} from "../Univ";
function WorkerPayments() {
    const {assignmentId} = useParams();
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(false);
    // ---------------- FETCH PAYMENTS ----------------
    const fetchPayments = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                baseUrl + "payment-assignment/" + assignmentId + "/"
            );
            setPayments(res.data);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchPayments();
    }, [assignmentId]);
    // ---------------- CONFIRM PAYMENT ----------------
    const confirmPayment = async (paymentId) => {
        try {
            await axios.patch(
                baseUrl + "update-payment/" + paymentId + "/",
                {
                    worker_confirmed: true
                }
            );
            Swal.fire(
                "Success",
                "Payment confirmed",
                "success"
            );
            fetchPayments();
        } catch (err) {
            console.log(err.response?.data);
            Swal.fire(
                "Error",
                "Unable to confirm payment",
                "error"
            );
        }
    };
    // ---------------- TOTAL PAID ----------------
    const totalPaid = payments.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );
    return (
        <section className="container mt-4">

            <div className="d-flex justify-content-between align-items-center mb-3">

                <h3>
                    Payment History
                </h3>

                <div className="alert alert-success mb-0">

                    <strong>
                        Total Received : ₹{totalPaid}
                    </strong>

                </div>

            </div>

            {loading && (
                <div className="alert alert-info">

                    Loading Payments...

                </div>
            )}

            {!loading && payments.length === 0 && (
                <div className="alert alert-warning">

                    No Payments Found

                </div>
            )}

            <div className="row">

                {payments.map((payment) => (
                    <div
                        key={payment.id}
                        className="col-md-4 mb-4"
                    >

                        <div className="card shadow h-100">

                            <div className="card-body">

                                <h5 className="text-success">

                                    ₹{payment.amount}

                                </h5>

                                <hr/>

                                <p>
                                    <strong>Date :</strong>{" "}
                                    {payment.payment_date}
                                </p>

                                <p>
                                    <strong>Mode :</strong>{" "}
                                    {payment.payment_mode}
                                </p>

                                <p>
                                    <strong>Reference :</strong>{" "}
                                    {payment.transaction_reference || "-"}
                                </p>

                                <p>
                                    <strong>Remarks :</strong>{" "}
                                    {payment.remarks || "-"}
                                </p>

                                <hr/>

                                <p>

                                    <strong>Owner Status :</strong>{" "}

                                    {payment.owner_confirmed ? (
                                        <span className="badge bg-success">
                      CONFIRMED
                    </span>
                                    ) : (
                                        <span className="badge bg-warning">
                      PENDING
                    </span>
                                    )}

                                </p>

                                <p>

                                    <strong>Worker Status :</strong>{" "}

                                    {payment.worker_confirmed ? (
                                        <span className="badge bg-success">
                      RECEIVED
                    </span>
                                    ) : (
                                        <span className="badge bg-danger">
                      NOT CONFIRMED
                    </span>
                                    )}

                                </p>

                            </div>

                            <div className="card-footer">

                                {!payment.worker_confirmed && (
                                    <button
                                        className="btn btn-primary w-100"
                                        onClick={() =>
                                            confirmPayment(payment.id)
                                        }
                                    >
                                        Confirm Received
                                    </button>
                                )}

                                {payment.worker_confirmed && (
                                    <button
                                        className="btn btn-success w-100"
                                        disabled
                                    >
                                        Payment Confirmed
                                    </button>
                                )}

                            </div>

                        </div>

                    </div>
                ))}

            </div>

        </section>
    );
}
export default WorkerPayments;